/**
 * The recurrence range type
 */ export var RecurrenceRangeType;
(function(RecurrenceRangeType) {
    /** Recurrence stops after a given end date. If it matches the pattern, the last occurrence will be on the end date. */ RecurrenceRangeType["EndDate"] = "endDate";
    /** Recurrence continues indefinitely; it will only end with manual intervention */ RecurrenceRangeType["NoEnd"] = "noEnd";
    /** Recurrence ends after a given number of events */ RecurrenceRangeType["Numbered"] = "numbered";
})(RecurrenceRangeType || (RecurrenceRangeType = {}));
